// Use Case
export const FETCH_USE_CASE_LIST = 'FETCH_USE_CASE_LIST';
